module.exports = __webpack_public_path__ + "img/temp1.447a49f9.png";